import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, Grid, Icon, IconButton, Stack, Toolbar, Typography } from '@mui/material';
import { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import OAuthService from 'src/app/auth/services/oAuthService';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import Select from "react-select";
import customStyles from 'app/shared-components/SelectCustomStyle';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const docTypes = [
    {
      value: "02",
      label: "PDF",
    },
    {
      value: "03",
      label: "JPEG",
    },
    {
      value: "05",
      label: "EXCEL",
    },
    {
      value: "06",
      label: "WORD PAD",
    },
    {
      value: "07",
      label: "POWERPOINT",
    },
    {
      value: "08",
      label: "WINRAR",
    },
  ];

  const uploadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileUpload}`;

const handleFileName = forwardRef((props, ref) => {
    const [openDoc, setOpenDoc] = useState(false);
    const [rowIndex, setRowIndex] = useState(null);
    const [filePath, setFilePath] = useState("");
    const [fileName, setFileName] = useState("");
    const [fileType, setFileType] = useState("PDF");

    const handleAddDoc = async (data, rowId) => {
        setOpenDoc(!openDoc);
        setRowIndex(rowId);
        const path = data?.fileUrl;
        const parts = path.split("/");
        const lastPart = parts[parts.length - 1];
        setFilePath(data?.fileUrl);
        setFileName(lastPart);
    };

    const handleDownload = async () => {
        if (filePath !== undefined) {
          const downloadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileDownload}`;
          const download = await OAuthService.getDownload(
            downloadUrl + `/${fileName}`
          );
          const blob = download?.data;
          if (blob) {
            const url = window.URL.createObjectURL(
              new Blob([blob], { type: "application/octet-stream" })
            );
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          }
        }
      };

      const removeDocument = () => {
        setFileName(null);
        setFileType(null);
        setFilePath(null);
      };

      const handleDocumentChange = async (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
    
        await OAuthService.uploadFile(uploadUrl, formData)
          .then((resp) => {
            const data = resp?.data;
            if (data.error === undefined) {
              if (rowIndex !== -1) {
                updatedData[rowIndex] = {
                  fileUrl: data?.downloadUri,
                };
                console.log('updatedData', updatedData);
              }
    
              setFilePath(data?.downloadUri);
              setFileName(data?.fileName);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      };

      useImperativeHandle(ref, () => {
        return {
            getValue() {
                const rowData = props.node;
                rowData.setDataValue("file", fileName);
                return fileName;
            }
        };
    });

    return (
      <>
        <IconButton onClick={() => handleAddDoc(props.data, props.rowIndex)}>
          <FuseSvgIcon size={12} color="primary">
            heroicons-outline:upload
          </FuseSvgIcon>
        </IconButton>

        <Dialog open={openDoc} fullWidth maxWidth="sm" component="form">
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Document Upload
            </Typography>
            <IconButton onClick={() => handleAddDoc()}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 pb-0 sm:p-24 sm:pb-0" }}>
          <Grid
            container
            spacing={2}
            className="pb-16"
            direction={"row"}
            alignItems={"center"}
          >
            {fileName === null || fileName.length === 0 ? (
              <Grid xs={6} item>
                <div>
                  <label>Doc Typename</label>
                </div>
                <Stack>
                  <Select
                    className="basic-multi-select mb-4"
                    name="name"
                    required
                    value={fileType}
                    onChange={(val) => {
                      setFileType(val);
                      setFileName(null);
                      setFilePath(null);
                    }}
                    options={docTypes}
                    styles={customStyles()}
                  />
                </Stack>
              </Grid>
            ) : null}
            <Grid xs={12} item>
              {fileName === null || fileName.length === 0 ? (
                <Stack className="w-full mb-16">
                  <Box
                    className="flex justify-center items-center"
                    sx={{
                      height: 180,
                      border: "1px dotted grey",
                    }}
                  >
                    <CloudUploadIcon fontSize={"large"} />
                    <Typography className="ml-12">Upload your image</Typography>

                    <Button
                      variant="contained"
                      component="label"
                      color="warning"
                      className="ml-12"
                    >
                      <input
                        hidden
                        type="file"
                        accept={
                          fileType?.value === "02"
                            ? ".pdf"
                            : fileType?.value === "03"
                            ? ".jpeg"
                            : fileType?.value === "05"
                            ? ".xlsx"
                            : fileType?.value === "06"
                            ? ".rtf,.docx"
                            : fileType?.value === "07"
                            ? ".ppt,.pptx"
                            : fileType?.value === "08"
                            ? ".rar,.zip"
                            : ".pdf"
                        }
                        onChange={(e) => handleDocumentChange(e)}
                      />
                      <Typography color="black">Browse</Typography>
                    </Button>
                  </Box>
                  {/* <Typography color="red">{item.error}</Typography> */}
                </Stack>
              ) : (
                <Stack className="w-full mb-16">
                  <Box className="flex justify-between items-center">
                    <Grid className="flex">
                      <div>
                        <FileCopyIcon
                          fontSize={"large"}
                          color="warning"
                          className=" mt-20"
                        />
                      </div>
                      <div>
                        <Typography fontSize={"large"} className="ml-12 mt-20">
                          {fileName}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid>
                      <FuseSvgIcon
                        className=" w-32 h-32 cursor-pointer"
                        onClick={() => removeDocument()}
                      >
                        heroicons-outline:x
                      </FuseSvgIcon>
                    </Grid>
                    <Grid>
                      {" "}
                      <IconButton
                        className="ml-24 w-32 h-32 cursor-pointer"
                        onClick={() => handleDownload()}
                      >
                        <Icon>download</Icon>
                      </IconButton>
                    </Grid>
                  </Box>
                </Stack>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{ background: "#373c42" }}
          className="justify-between px-16 sm:px-16"
        >
          <Box>&nbsp;</Box>
          <Button
            variant="contained"
            color="primary"
            type="button"
            onClick={() => {
              setOpenDoc(!openDoc);
            }}
            // disabled={alreadyExistsError || btnDisabled}
          >
            {"Save & Exit"}
          </Button>
        </DialogActions>
      </Dialog>
      </>
    );

})

export default handleFileName